module.exports = __webpack_public_path__ + "static/media/ritcher.c69b783d.webm";